// extracted by mini-css-extract-plugin
module.exports = {"btnDownload":"DownloadButton_btnDownload__2tfWZ"};